const ExternalRedirect = ({ to }) => {
  window.location.href = to;
  return null;
};

export default ExternalRedirect;
